import {RegisterAbsenceRequest} from "../../lib/types/absence";
import {postRequest} from "../../http-client/http-client";

export async function registerAbsence(request: RegisterAbsenceRequest) {
    return postRequest(`/absence`, undefined, JSON.stringify(request));
}
